import './HistoryChart.less';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { AppLocaleProvider } from 'sd-ui-components';

const { injectIntl } = AppLocaleProvider;

let counter = 0;

@inject('SafetyStore')
@observer
class CustomizedLabel extends React.Component {
  render() {
    const {
      x,
      y,
      connectNulls,
      value,
      SafetyStore,
      targetScores,
      index
    } = this.props;

    let id = `sd-ui-driver-safety-history-score-row-${counter++}`;

    let safetyScore = SafetyStore.safetyScoreIsValid(value)
      ? Number(value)
      : null;

    let targetScore = SafetyStore.safetyScoreIsValid(targetScores[index])
      ? Number(targetScores[index])
      : null;

    // style class names
    const noTargetColor = 'safety-chart-no-target-text',
      targetLessThanScoreColor = 'safety-chart-target-less-than-score-text',
      targetGreaterThanScoreColor =
        'safety-chart-target-greater-than-score-text';

    // Don't set value if there is no value or this is the dotted line
    if (safetyScore === null || connectNulls === true) {
      return null;
    }

    return (
      <g>
        <text
          x={x}
          y={y - 23}
          className={
            targetScore === null
              ? noTargetColor
              : safetyScore <= targetScore
              ? targetGreaterThanScoreColor
              : targetLessThanScoreColor
          }
          data-automation-id={id}
        >
          <tspan x={x} dy="0.355em">
            {this.props.intl.formatNumber(safetyScore, {
              useGrouping: false
            })}
          </tspan>
        </text>
      </g>
    );
  }
}

export default injectIntl(CustomizedLabel);



// WEBPACK FOOTER //
// ./src/containers/Safety/HistoryChart/CustomizedLabel.jsx